export default __webpack_public_path__ + "static/media/dc.f1c5ed2b.JPG";